import React, { memo } from "react";
import {  faLightbulb,
          faGlobe,
          faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './about-us.css';
import './../../assets/css/style.css';
import './../home/home.css';


function AboutUs() {
  return (
    <>
      <h2>About Us</h2>

      {/* PRESENTATION CARD */}
      <div className="container responsive-container-top">
        <div className="presentation-card about-us-description card-shadow">
          <p className="p-reading-text pb-2">
            The <b>Alexandria Research Center for Adaptation to Climate Change (ARCA)</b> was established in 2011 through a research initiative funded by IDRC-Canada. Guided by values of excellence, diversity, social responsibility, and integrity, ARCA serves as a leading center for integrated climate change adaptation research. We promote knowledge sharing, foster collaborative, policy-driven research, and facilitate the exchange of experiences and best practices to address the challenges of climate change.
          </p>
        </div>

      </div>

      <div className="services-presentation-cards">
        {/* Vision card */}
        <div className="presentation-card card-shadow card-style-arca-plants">
          <h3>
            <span className="important-title"><FontAwesomeIcon icon={faLightbulb} />&nbsp;&nbsp;&nbsp;</span>
            Our Vision
          </h3>
          <hr />
          <p className="p-reading-text">
            Advancing integrated, policy-driven climate change adaptation research, fostering a center of excellence that promotes collaboration, knowledge-sharing, and the exchange of best practices to drive sustainable solutions for the future.
          </p>
        </div>

        {/* Mission card */}
        <div className="presentation-card card-shadow card-style-arca-sun">
          <h3>
            <span className="important-title"><FontAwesomeIcon icon={faGlobe} />&nbsp;&nbsp;&nbsp;</span>
            Our Mission
          </h3>
          <hr />
          <p className="p-reading-text">
            Establishing a multidisciplinary, rigorous hub for climate change adaptation research that empowers cross-cutting decision-making and informs effective policy development.
          </p>
        </div>
      </div>

      {/* Objectives card */}
      <div className="container responsive-container-bottom">
        <div className="presentation-card card-shadow card-style-arca-waves">
          <h3>
            <span className="important-title"><FontAwesomeIcon icon={faClipboardCheck} />&nbsp;&nbsp;&nbsp;</span>
            Our Objectives
          </h3>
          <hr />
          <ul className="bullet-li">
            <li>
              <p className="p-reading-text">
                <b>Develop institutional research capacities: </b>
                by establishing robust management structures, strategic plans, evaluation frameworks, and fostering strong partnerships and networks.
              </p>
            </li>
          </ul>
                    
          <ul className="bullet-li">
            <li>
              <p className="p-reading-text">
                <b>Enhance research competencies: </b>
                through studentship awards, targeted training workshops, and mentoring programs that build technical and research skills.
              </p>
            </li>
          </ul>  
          
          <ul className="bullet-li">
            <li>
              <p className="p-reading-text">
                <b>Support effective policy-research integration: </b>
                by analyzing research needs for policymakers, promoting capacity building, and facilitating networking and communication channels.
              </p>
            </li>
          </ul>  
          

          <ul className="bullet-li">
            <li>
              <p className="p-reading-text">
                <b>Conduct rigorous research to inform decision-making and policy: </b>
                through small grants projects and focused research on the economics of climate change adaptation.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default memo(AboutUs);